<template>
  <div class="flex justify-center">
    <div v-if="!editProjectValue" class="flex gap-2 justify-center text-center">
      <div class="flex justify-center items-center gap-2" v-if="!overView">
        <span class="p-1">Name</span>
        <input v-model="name" :readonly="true" data-ui="project-name"
               class="border border-trader-input-border   w-[150px] p-1 text-center shadow-inner-2">
      </div>
      <div class="flex justify-center items-center gap-2 ">
        <span class="p-1">Von</span>
        <input v-model="from" :readonly="true" data-ui="project-start-date"
               class="border border-trader-input-border p-1 w-[150px]  text-center shadow-inner-2">
      </div>
      <div class="flex justify-center items-center gap-2">
        <span class="p-1">Bis</span>
        <input v-model="to" :readonly="true" data-ui="project-end-date"
               class="border border-trader-input-border p-1 w-[150px] text-center shadow-inner-2">
      </div>
      <div class="flex justify-center items-center  gap-2">
        <i class="fa-solid fa-pencil ml-1 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text hover:cursor-pointer"
           title="bearbeiten" data-ui="edit-article-number" @click="changeProjekt"></i>
      </div>
    </div>

    <div v-else class="flex justify-center items-center gap-2">
      <div class="flex gap-2">
        <div class="flex justify-center items-center gap-2">
          <span class="p-1">Name</span>
          <input v-model="newName" data-ui="edit-project-name" class="border border-trader-input-border  w-[150px] p-1 text-center shadow-inner-2">
        </div>
        <div class="flex justify-center items-center gap-2 ">
          <span class="p-1">Von</span>

          <input v-model="newStartTime" type="date" data-ui="edit-project-start-date"
                 class="border border-trader-input-border p-1 w-[150px] text-center shadow-inner-2">
        </div>
        <div class="flex justify-center items-center gap-2">
          <span class="p-1">Bis</span>
          <input v-model="newEndTime" type="date" data-ui="edit-project-end-date"
                 class="border border-trader-input-border p-1 w-[150px] text-center shadow-inner-2">
        </div>
        <i class="fa-solid fa-check  p-2 bg-trader-green hover:bg-trader-hover-background hover:text-trader-hover-text text-trader-dark-green hover:cursor-pointer "
           title="speichern" data-ui="edit-article-number" @click="editProject()"></i>
        <i class="fa-solid fa-circle-xmark  p-2 bg-trader-red hover:bg-trader-hover-background text-trader-dark-red hover:text-trader-hover-text hover:cursor-pointer"
           title="abbrechen" @click="changeProjekt()" data-ui="save-article-number"></i>
      </div>
    </div>
  </div>
</template>


<script>
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";

export default {
  props: {
    projectIdProp: {
      type: Number,
      default: 0
    },
    overView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newName: '',
      newStartTime: '',
      newEndTime: '',
      name: '',
      from: null,
      to: null,
      dateFrom: null,
      dateTo: null,

      showError: false,
      projectId: null,
      accordionIndex: 0,
      magazineId: null,
      editProjectValue: false,
    }
  },
  watch: {
    // watch params magazineId
    '$route.params': {
      handler: function (params) {
        this.magazineId = params.magazineId;
        this.projectId = params.projectId;
        this.getProjects();
      },
      deep: true
    },
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  methods: {
    removeAfterComma(dateString) {
      // Den Teil vor dem Komma extrahieren
      let cleanedDate = dateString.split(',')[0].trim();
      return cleanedDate;
    },
    formatDate(unixTimestamp) {
      const date = new Date(unixTimestamp * 1000); // Das Multiplizieren mit 1000 ist notwendig, da JavaScript Millisekunden erwartet.
      return date.toLocaleString(); // Dies gibt das Datum und die Uhrzeit in einem lokalisierten Format zurück.
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;

    },
    async editProject() {

      let id
      if (this.projectIdProp == 0) {
        id = this.projectId;
      } else {
        id = this.projectIdProp;
      }

      const projectData = {
        projectId: id,
        name: this.newName,
        from: this.newStartTime,
        to: this.newEndTime
      };

      const mutation = gql`
        mutation editProject($project: ProjectInputValue!) {
           editProject(project: $project) {
            success
          }
        }
      `;

      try {
        const variables = {
          project: projectData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        this.editProjectValue = !this.editProjectValue;
        await this.getProjects();
      } catch (error) {
        console.error(error);

      }
    }
    ,
    async getProjects() {
      let id
      if (this.projectIdProp == 0) {
        id = this.projectId;
      } else {
        id = this.projectIdProp;
      }

      try {
        // Apollo Client Anfrage
        const response = await apolloClient.query({
          query: gql`
        query projects($filter: QueryFilter) {
          projects(filter: $filter) {
            name
            startTimestamp
            endTimestamp
          }
        }
      `,
          variables: {
            filter: {

              projectId: id  // Korrektur der Variable
            }
          }
        });
        this.projectData = response.data.projects;
        if (this.projectData && this.projectData.length > 0) {
          this.name = this.projectData[0].name;
          this.newStartTime = this.formatTimestamp(this.projectData[0].startTimestamp)
          this.newEndTime = this.formatTimestamp(this.projectData[0].endTimestamp)
          this.from = this.formatDate(this.projectData[0].startTimestamp);
          this.to = this.formatDate(this.projectData[0].endTimestamp);
        }

      } catch (error) {
        console.error("Fehler beim Abrufen der projects:", error);
      }
    }
    ,
    changeProjekt() {
      this.newName = this.name
      this.editProjectValue = !this.editProjectValue;
    }
    ,
  },
  mounted() {
    this.getProjects();
  }
  ,
  created() {
    this.projectId = this.$route.params.projectId;
    this.getProjects();

  }
  ,

}
</script>
